import "./index.css";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

type DiscountFlagProps = {
  type: string | undefined;
  color: string;
  value: number;
  isList: boolean;
  isDetailProductPage?: boolean;
};

export function DiscountFlag({
  type,
  color,
  value,
  isDetailProductPage,
  isList,
}: DiscountFlagProps) {
  const location = useLocation();
  const [urlContext, setUrlContext] = useState(false);

  useEffect(() => {
    setUrlContext(location.pathname.includes("product"));
  }, [location.pathname]);

  if (type == null) return null;

  const getDiscountComponent = () => {
    switch (type) {
      case "square":
        return (
          <div
            className={`flag-discount-item  ${
              isList ? "flag-discount-square-list" : "flag-discount-square"
            }`}
          >
            <div className="flag-discount-paragraph">
              <p>
                <b>{value}%</b>
                <br />
                off
              </p>
            </div>
            <svg
              style={{ marginLeft: 0 }}
              width="58"
              height="47"
              viewBox="0 0 58 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_6746_10276)">
                <path
                  d="M7.03444 38.9892C21.5601 38.9513 38.6614 38.9608 39.3496 38.9608C39.3496 37.3518 39.3392 35.8278 39.3496 34.3134C39.3705 32.8273 39.047 32.0134 40.34 32.0228C41.6331 32.0228 41.2992 32.8463 41.32 34.3323C41.3304 35.8184 41.32 37.3044 41.32 38.9703C43.124 38.9703 48.2961 38.9135 50.9343 38.9987C50.9447 38.9987 50.9551 38.9987 50.976 38.9987C52.6444 39.046 54 37.8061 54 36.3579L54 26.3153C53.4369 25.4161 52.5506 25.1037 51.4035 25.009C48.2127 24.744 45.9186 22.4913 45.9603 19.7843C46.002 17.1151 48.2752 14.9475 51.4035 14.692C52.5506 14.5973 53.4473 14.285 54 13.3858L54 3.38102C54 1.92337 52.6653 0.683414 50.976 0.702343C50.9656 0.702343 50.9551 0.702343 50.9343 0.702343C46.6694 0.7686 45.929 0.730766 41.4452 0.730765C41.4452 2.31146 41.4452 3.83538 41.4452 5.35928C41.4347 6.87371 41.7999 7.66875 40.5173 7.67821C39.2347 7.68768 39.5478 6.86422 39.5373 5.38764C39.5269 3.9016 39.5373 2.40611 39.5373 0.730765C38.9221 0.730765 21.6331 0.740201 7.0553 0.702339C5.36603 0.702339 4 1.88553 4 3.34318L4 36.3484C4 37.8061 5.36602 38.9892 7.0553 38.9892L7.03444 38.9892ZM41.393 26.9778C41.3409 27.9622 41.6018 28.5017 40.5486 28.5207C39.412 28.5396 39.6937 27.9528 39.5582 26.94C39.4748 26.2869 39.5373 25.6243 39.5373 24.9712C39.5373 24.356 39.4435 23.7313 39.5582 23.135C39.7459 22.16 39.412 21.5353 40.5799 21.5921C41.6539 21.6394 41.3409 22.2073 41.393 23.1728C41.466 24.4411 41.4556 25.719 41.393 26.9873L41.393 26.9778ZM39.5895 12.6286C39.6833 11.6915 39.4641 11.133 40.5277 11.1614C41.5809 11.1898 41.2887 11.7104 41.393 12.6948C41.466 13.3479 41.4034 14.0105 41.4034 14.6636C41.4034 14.6636 41.4034 14.6636 41.4139 14.6636C41.4139 15.2788 41.466 15.894 41.4034 16.4998C41.2887 17.5315 41.6018 18.1089 40.4547 18.0994C39.3703 18.0994 39.6625 17.4937 39.579 16.5661C39.4643 15.2599 39.4539 13.9348 39.5895 12.6286Z"
                  fill={`${color}`}
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_6746_10276"
                  x="0"
                  y="0.702148"
                  width="58"
                  height="46.2979"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6746_10276"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6746_10276"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        );
      case "rectangular":
        return (
          <div
            className={`${
              urlContext ? "flag-discount-item-rectangle" : "flag-discount-item"
            } ${
              isList
                ? "flag-discount-rectangle-list"
                : "flag-discount-rectangle"
            }`}
          >
            <div className="flag-discount-paragraph">
              <p>
                <b>{value}%</b>
                <br />
                off
              </p>
            </div>
            <svg
              style={{ marginLeft: 0 }}
              width="63"
              height="41"
              viewBox="0 0 63 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_6746_10256)">
                <path
                  d="M54.4579 16.4307C54.4579 13.9232 56.4925 11.8886 58.989 11.8886V4.4871C56.5035 4.4871 54.4909 2.4855 54.4579 0H8.46511C8.43211 2.46351 6.45251 4.44311 4 4.4871V11.9986C6.47451 12.0316 8.47611 14.0442 8.47611 16.5297C8.47611 19.0152 6.47451 21.0278 4 21.0608V28.5723C6.44151 28.6053 8.41012 30.5629 8.46511 33.0044H54.4689C54.4689 33.0044 54.4689 32.9494 54.4689 32.9164C54.4689 30.4089 56.5035 28.3743 59 28.3743V20.9728C56.4925 20.9728 54.4689 18.9382 54.4689 16.4307H54.4579Z"
                  fill={`${color}`}
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_6746_10256"
                  x="0"
                  y="0"
                  width="63"
                  height="41.0044"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6746_10256"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6746_10256"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        );
      case "round":
        return (
          //   <div className="flag-discount-item flag-discount-round">
          <div
            className={`${
              urlContext ? "flag-discount-item-round" : "flag-discount-item"
            } ${
              isList ? "flag-discount-round-list " : " flag-discount-round "
            }`}
          >
            <div className="flag-discount-paragraph">
              <p>
                <b>{value}%</b>
                <br />
                off
              </p>
            </div>
            <svg
              style={{ marginLeft: 0 }}
              width="58"
              height="58"
              viewBox="0 0 58 58"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_6746_10240)">
                <path
                  d="M54 25C54 27.0016 53.8629 28.3669 53.4186 30.2326C53.4186 30.2326 53.4186 30.2326 45.2791 38.3721C34.2326 49.4515 34.2326 49.4515 34.2326 49.4515C32.5451 49.8109 30.7946 50 29 50C15.1929 50 4 38.8071 4 25C4 11.1929 15.1929 0 29 0C42.8071 0 54 11.1929 54 25Z"
                  fill={`${color}`}
                />
                <g filter="url(#filter1_d_6746_10240)">
                  <path
                    d="M34.2322 49.3704C34.2322 38.8008 42.8006 30.2325 53.3701 30.2325L34.2322 49.3704Z"
                    fill="#3C3C3C"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_d_6746_10240"
                  x="0"
                  y="0"
                  width="58"
                  height="58"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6746_10240"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6746_10240"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d_6746_10240"
                  x="27.2322"
                  y="26.2325"
                  width="27.1379"
                  height="27.1379"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-3" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6746_10240"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6746_10240"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        );
      case "trigonal":
        return (
          <div
            className={`flag-discount-item ${
              isList ? "flag-discount-trigonal-list" : "flag-discount-trigonal"
            }`}
          >
            <div className={`flag-discount-paragraph `}>
              <p>
                <b>{value}%</b>
                <br />
                off
              </p>
            </div>
            <svg
              style={{ marginLeft: 0 }}
              width="64"
              height="50"
              viewBox="0 0 64 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7436_89)">
                <path
                  d="M58.1705 16.508C58.1683 16.5125 58.1622 16.5135 58.1586 16.5099L44.3423 2.4986C42.7735 0.90769 40.6326 -6.27283e-05 38.4178 -6.29219e-05L13.0335 -6.51411e-05C8.41027 -6.55453e-05 4.66367 3.79004 4.67289 8.47854L4.67289 33.512C4.67289 38.2098 8.41949 41.9999 13.0428 41.9999L38.4178 41.9999C40.6326 41.9999 42.7643 41.1109 44.3423 39.5106L58.1567 25.4919C60.6089 23.0145 60.6114 18.9867 58.1825 16.5061C58.1789 16.5024 58.1728 16.5034 58.1705 16.508ZM52.0569 24.7245C50.1929 26.6149 47.1661 26.6149 45.2928 24.7245C43.4287 22.8342 43.4287 19.7553 45.2928 17.8649C47.1568 15.9745 50.1836 15.9745 52.0569 17.8649C53.921 19.7553 53.921 22.8342 52.0569 24.7245Z"
                  fill={`${color}`}
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7436_89"
                  x="0.672852"
                  y="-6.10352e-05"
                  width="63.3271"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7436_89"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7436_89"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        );
      default:
        return (
          <div
            className={`flag-discount-item ${
              isList ? "flag-discount-trigonal-list" : "flag-discount-trigonal"
            }`}
          >
            <div className="flag-discount-paragraph">
              <p>
                <b>{value}%</b>
                <br />
                off
              </p>
            </div>
            <svg
              style={{ marginLeft: 0 }}
              width="64"
              height="50"
              viewBox="0 0 64 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7436_89)">
                <path
                  d="M58.1705 16.508C58.1683 16.5125 58.1622 16.5135 58.1586 16.5099L44.3423 2.4986C42.7735 0.90769 40.6326 -6.27283e-05 38.4178 -6.29219e-05L13.0335 -6.51411e-05C8.41027 -6.55453e-05 4.66367 3.79004 4.67289 8.47854L4.67289 33.512C4.67289 38.2098 8.41949 41.9999 13.0428 41.9999L38.4178 41.9999C40.6326 41.9999 42.7643 41.1109 44.3423 39.5106L58.1567 25.4919C60.6089 23.0145 60.6114 18.9867 58.1825 16.5061C58.1789 16.5024 58.1728 16.5034 58.1705 16.508ZM52.0569 24.7245C50.1929 26.6149 47.1661 26.6149 45.2928 24.7245C43.4287 22.8342 43.4287 19.7553 45.2928 17.8649C47.1568 15.9745 50.1836 15.9745 52.0569 17.8649C53.921 19.7553 53.921 22.8342 52.0569 24.7245Z"
                  fill={`${color}`}
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7436_89"
                  x="0.672852"
                  y="-6.10352e-05"
                  width="63.3271"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7436_89"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7436_89"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        );
    }
  };

  return (
    <div
      className={
        isDetailProductPage
          ? "flag-discount-product"
          : isList
          ? "flag-discount-list"
          : "flag-discount"
      }
    >
      {getDiscountComponent()}
    </div>
  );
}
